<template>
  <div
    :class="{ 'bg-white': !nightMode, 'bg-dark': nightMode }"
    class="pt-5 p-st"
  >
    <div
      class="container"
      data-aos="fade"
      data-aos-once="true"
      data-aos-duration="1000"
    >
      <div class="row align-items-center">
        <div class="col-xl-6 col-bg-6 col-md-6 col-sm-12 text-center">
          <img :src="picture" />
        </div>
        <div class="col-xl-6 col-bg-6 col-md-6 col-sm-12 pt-5">
          <span
            class="home-title"
            :class="{ pgray: !nightMode, 'text-light': nightMode }"
          >
            {{ displayedTitle }}<span v-if="typingTitle" class="cursor">|</span>
          </span>
          <div>
            <p>
              {{ displayedDescription }}<span v-if="typingDescription" class="cursor">|</span>
            </p>
          </div>
          <div class="text-center pb-4">
            <button
              class="btn btn-outline-secondary mx-2 "
              @click="open('linkedin')"
              v-tooltip.bottom="'LinkedIn'"
            >
              <i class="fab fa-linkedin"></i>
            </button>
            <button
              class="btn btn-outline-secondary mx-2"
              @click="open('github')"
              v-tooltip.bottom="'GitHub'"
            >
              <i class="fab fa-github"></i>
            </button>
            <button
              class="btn btn-outline-secondary mx-2"
              @click="open('Instagram')"
              v-tooltip.bottom="'Instagram'"
            >
              <i class="fab fa-instagram"></i>
            </button>
            <button
              class="btn btn-outline-secondary mx-2"
              @click="open('resume')"
              v-tooltip.bottom="'Resume'"
            >
              <i class="fa fa-file"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import info from "../../info";

export default {
  name: "Home",
  components: {
  },
  props: {
    nightMode: {
      type: Boolean,
    },
  },
  data() {
    return {
      picture: info.flat_picture,
      greeting: `Hi, I'm ${info.name}!`,
      description: info.description,
      displayedTitle: "",
      displayedDescription: "",
      typingTitle: false,
      typingDescription: false,
      typeTimeout: null,
      linkedin: info.links.linkedin,
      github: info.links.github,
      Instagram: info.links.instagram,
      resume: info.links.resume
    };
  },
  mounted() {
    this.typingTitle = true;
    this.typeText(this.greeting, "displayedTitle", 75, () => {
      this.typingTitle = false;
      this.typingDescription = true;
      this.typeText(this.description, "displayedDescription", 25, () => {
        this.typingDescription = false;
      });
    });
  },
  beforeDestroy() {
    if (this.typeTimeout) {
      clearTimeout(this.typeTimeout);
    }
  },
  methods: {
    typeText(text, field, speed, onComplete) {
      let index = 0;
      const typeNext = () => {
        if (index < text.length) {
          this[field] += text.charAt(index);
          index += 1;
          this.typeTimeout = setTimeout(typeNext, speed);
        } else if (onComplete) {
          onComplete();
        }
      };
      typeNext();
    },
    open(link) {
      switch (link) {
        case "linkedin":
          window.open(this.linkedin, "_blank");
          break;
        case "github":
          window.open(this.github, "_blank");
          break;
        case "Instagram":
          window.open(this.Instagram, "_blank");
          break;
        case "resume":
          const resumePath = this.resume;
          const a = document.createElement('a');
          a.href = resumePath;
          a.download = 'Nicholas_Wong_Resume.pdf';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          break;
      }
    },
  },
};
</script>

<style scoped>
.home-title {
  font-size: 28px;
  font-weight: 500;
  display: block;
  min-height: 1.4em;
}

.cursor {
  display: inline-block;
  margin-left: 1px;
  font-weight: 300;
  animation: blink 0.8s step-end infinite;
}

@keyframes blink {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
}

img {
  max-width: 300px;
  margin-top: 60px;
  margin-bottom: 60px;
  transform: rotateY(180deg);
  animation: float 3s ease-in-out infinite;
}

@keyframes float {
  0% {
    transform: rotateY(180deg) translateY(0px);
  }
  50% {
    transform: rotateY(180deg) translateY(-10px);
  }
  100% {
    transform: rotateY(180deg) translateY(0px);
  }
}

@media only screen and (max-width: 580px) {
  img {
    object-fit: cover;
    border-radius: 50%;
    height: 200px;
    width: 200px;
    margin-top: 10px;
    margin-bottom: 10px;
    border: 2px solid rgb(205, 205, 205);
  }
}

.fa {
  font-size: 15px;
}

.btn {
  border-color: #669db3ff;
  color: #669db3ff;
}

.btn:hover {
  background-color: #669db3ff;
  border-color: #669db3ff;
  color: white;
}

.btn:focus {
  background-color: #669db3ff;
  border-color: #669db3ff;
  color: white;
}

.btn:focus {
  outline: none !important;
}

p {
  text-align: justify;
  font-weight: 400;
  min-height: 4.5em;
}

/* LEAVES */
</style>
